module.exports = __webpack_public_path__ + "media/images/tools-8b9a34e95fea59bf11234343bd27c34e.svg";